export default __webpack_public_path__ + "static/blonde-performance-logo-60e70b23fff53613272aaa164db15780.svg";